import type React from 'react';
import { useEffect } from 'react';

import { OnboardingProgressStep, type ProgressStep, useProgress } from '@/context/progress';
import BaseLayout from '@/layouts/base';

interface VerificationLayoutProps extends React.ComponentPropsWithoutRef<typeof BaseLayout> {
  currentStep?: ProgressStep | null;
  progress?: number;
}

const VerificationLayout = ({ currentStep = OnboardingProgressStep.PERSONAL_TRADING_INFORMATION, progress, ...props }: VerificationLayoutProps) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    if (currentStep) {
      return setCurrentStep(currentStep, progress);
    }
  }, [currentStep, progress, setCurrentStep]);

  return <BaseLayout {...props} />;
};
VerificationLayout.displayName = 'VerificationLayout';

export default VerificationLayout;
